import React from 'react';
import { useDragToBoardStore } from '@/stores/dragToBoardStore';

export function DragOverlay() {
  const { isDragging, hoverBoardId, hoverPhase } = useDragToBoardStore();

  if (!isDragging || !hoverBoardId || hoverPhase === 'none') return null;

  return (
    <div 
      className="fixed inset-0 bg-black/10 pointer-events-none z-[50] transition-opacity duration-200"
      style={{
        opacity: hoverPhase === 'holding' || hoverPhase === 'opening' ? 0.15 : 0.08,
      }}
    />
  );
}
